import { ADDRESSES_CONTACTS_AREA } from '@convenia/common-organisms/SystemFields/content/consts'
import { pickSection } from '@convenia/employee-organisms/SystemFields/helpers'

export const mapSystemFields = (data = []) => ({
  address: pickSection(data, ADDRESSES_CONTACTS_AREA.ADDRESS, 'systemFields') || {},
  contacts: pickSection(data, ADDRESSES_CONTACTS_AREA.CONTACTS, 'systemFields') || {},
  emergencyContacts: pickSection(data, ADDRESSES_CONTACTS_AREA.EMERGENCY_CONTACTS, 'systemFields') || {},
})

export const mapCustomFields = (data = []) => ({
  address: pickSection(data, ADDRESSES_CONTACTS_AREA.ADDRESS, 'customFields') || {},
  contacts: pickSection(data, ADDRESSES_CONTACTS_AREA.CONTACTS, 'customFields') || {},
  emergencyContacts: pickSection(data, ADDRESSES_CONTACTS_AREA.EMERGENCY_CONTACTS, 'customFields') || {},
})
